<script setup lang="ts">
import { computed, ref } from 'vue';
import { RBtn } from '@therobotcompany/robco-frontend-library';
import gettext from '@/i18n/gettext';
import useAuthStore from '@/store/AuthStore';
import { Permission } from '@/models/Roles';

const props = defineProps<{
  controlUnitIp?: string;
  isOnline: boolean;
}>();

const data = ref(props);

const authStore = useAuthStore();
const { $gettext } = gettext;

const btnDisabled = computed(() => {
  return !data.value.isOnline || !data.value.controlUnitIp;
});
</script>
<template>
  <v-tooltip
    v-if="authStore.hasPermission(Permission.GET_ROBFLOW)"
    location="bottom"
    :disabled="!btnDisabled"
  >
    <template v-slot:activator="{ props }">
      <span v-bind="props">
        <r-btn
          variant="outlined"
          :disabled="btnDisabled"
          :href="`http://${data.controlUnitIp}/`"
          icon="mdi-open-in-new"
        >
          {{ $gettext('RobFlow') }}
        </r-btn>
      </span>
    </template>
    <span v-if="!data.isOnline">{{
      $gettext('Robot is currently offline')
    }}</span>
    <span v-else-if="!data.controlUnitIp">{{
      $gettext('Could not fetch Robot IP address')
    }}</span>
  </v-tooltip>
</template>
